module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-21-206bb4baf1cdbb0415a200c55b7126d8.png";